"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asColorLike = asColorLike;

var _color = require("./color.js");

/**
 * @module ol/colorlike
 */

/**
 * A type accepted by CanvasRenderingContext2D.fillStyle
 * or CanvasRenderingContext2D.strokeStyle.
 * Represents a color, pattern, or gradient. The origin for patterns and
 * gradients as fill style is an increment of 512 css pixels from map coordinate
 * `[0, 0]`. For seamless repeat patterns, width and height of the pattern image
 * must be a factor of two (2, 4, 8, ..., 512).
 *
 * @typedef {string|CanvasPattern|CanvasGradient} ColorLike
 * @api
 */

/**
 * @param {import("./color.js").Color|ColorLike} color Color.
 * @return {ColorLike} The color as an {@link ol/colorlike~ColorLike}.
 * @api
 */
function asColorLike(color) {
  if (Array.isArray(color)) {
    return (0, _color.toString)(color);
  } else {
    return color;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUhBOzs7O0FBS0E7Ozs7Ozs7Ozs7OztBQVlBOzs7OztBQUtNLFNBQVVBLFdBQVYsQ0FBc0JDLEtBQXRCLEVBQTJCO0VBQy9CLElBQUlDLEtBQUssQ0FBQ0MsT0FBTixDQUFjRixLQUFkLENBQUosRUFBMEI7SUFDeEIsT0FBTyxxQkFBU0EsS0FBVCxDQUFQO0VBQ0QsQ0FGRCxNQUVPO0lBQ0wsT0FBT0EsS0FBUDtFQUNEO0FBQ0YiLCJuYW1lcyI6WyJhc0NvbG9yTGlrZSIsImNvbG9yIiwiQXJyYXkiLCJpc0FycmF5Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9jb2xvcmxpa2UuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=